import styled from 'styled-components';

import { size } from '../../layout/helpers';
import { Container } from '../Container';
import { Dialog as ModalDialog } from '../Modal/wrapper';

export const Separator = styled.hr.withConfig({ componentId: 'sc-ua00r5-0' })`
    display: block;
    width: 100%;
    height: 1px;
    margin: 0;
    border: 0;
    background-color: var(--c-border-main);

    ${(props) => props.theme.breakpoint.LtSm} {
        height: ${size(1)};
        width: auto;
        background-color: var(--c-bg-alt);

        ${Container} &,
        .container & {
            margin: 0 ${size(-2)};
        }

        ${ModalDialog} & {
            margin: 0 calc(var(--dialog-gutter) * -1);
        }
    }
`;
